export enum PreApprovalType {
  true = "Yes",
  false = "No",
}
export class PreApprovalFilter {
  data: PreApprovalType;

  constructor(data: PreApprovalType) {
    this.data = data;
  }

  isGrantValid(grant): Boolean {
    if (this.data.toString() === "true") {
      return grant.timingOfFund
        ?.toLowerCase()
        .includes("Advance / pre-treatment".toLowerCase());
    } else if (this.data.toString() === "false") {
      return true;
    } else {
      return false;
    }
  }
}
